/* Calendar-day policy: no weekday, holiday or fulfillment-history adjustment. */
(() => {
  function deliveryRange(now = new Date()) {
    const parts = Object.fromEntries(new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/New_York', year: 'numeric', month: 'numeric', day: 'numeric'
    }).formatToParts(now).map(({ type, value }) => [type, value]));
    const anchor = Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day));
    return [5, 7].map(days => new Date(anchor + days * 86400000));
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = { deliveryRange };
  if (typeof customElements === 'undefined' || customElements.get('darido-calendar-delivery')) return;

  customElements.define('darido-calendar-delivery', class extends HTMLElement {
    connectedCallback() {
      this.refresh = () => {
        const target = this.querySelector('[data-delivery-dates]');
        if (!target) return;
        const dates = deliveryRange();
        const format = new Intl.DateTimeFormat('en-US', {
          timeZone: 'UTC', weekday: 'short', month: 'short', day: 'numeric',
          ...(dates[0].getUTCFullYear() !== dates[1].getUTCFullYear() ? { year: 'numeric' } : {})
        });
        target.textContent = `Estimated arrival: ${format.format(dates[0])} – ${format.format(dates[1])}. `;
      };
      this.refresh();
      this.timer = setInterval(this.refresh, 60000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
  });
})();
